module.exports = __webpack_public_path__ + "img/ic-left-menu-home-02.cd011e87.svg";